<template>
  <div>
    <div class="text-area">
      <!-- <quill-editor v-model:content="internalContent" :options="editorOption" @change="onEditorChange"/> -->
      <quill-editor class="ql-editor" ref="quillRef" v-model:content="internalContent" :options="options" @change="onEditorChange"/>
    </div>
    <div class="mt-3 mb-2 text-end">
      <button class="btn btn-primary fs-5" @click="saveDoc">
        문서저장
      </button>
    </div>
  </div>
</template>

<script>
import Quill from 'quill'
import ImageResize from 'quill-image-resize-vue'
Quill.register('modules/imageResize', ImageResize)

export default {
  name: 'CustomQuillEditor',
  props: {
    content: { type: String, default: "" },
    options: { type: Object, required: true }  // editorOption을 options로 받음
  },
  emits: ['update:content','saveDocument'],
  data() {
    return {
      internalContent: this.content, // props는 초깃값만
    }
  },
  watch: {
    content(newVal) {
      if (newVal !== this.internalContent) {
        this.internalContent = newVal // props 변경 시 내부 상태 동기화
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      // 에디터에 로드된 후 img에 불필요한 인라인 스타일 제거
      document.querySelectorAll('.ql-editor img').forEach(img => {
        img.style.float = '';
        img.style.margin = '';
        img.style.display = '';
      });
    });
  },

  methods: {
    onEditorChange({ html }) {
      this.internalContent = html // 내부 상태만 변경
      this.$emit('update:content', html) // 부모에 변경 알림
    },
    saveDoc() {
      const html = this.$refs.quillRef?.$el?.querySelector('.ql-editor')?.innerHTML || this.internalContent 
      this.$emit('saveDocument', { content: html })
      // this.$emit('saveDocument', { content: this.internalContent })
    }
  }
}
</script>

<style scoped>
.ql-toolbar {
  width: 100%;
}
.ql-container {
  width: 100%;
  height: 1000px;
}
.ql-editor {
  height: 1000px;
  width: 100%;
  overflow: scroll;
  overflow-x: hidden;
}

.ql-editor img {
  max-width: 100%;
  height: auto;
  /* display 속성 삭제 (정렬 전역 CSS가 대신 담당) */
}

/* 기존 float, margin 등 관련된 .float-right, .float-left, .ql-align-* 등은 필요 없다 */
</style>

